import { SignIn, SignUp } from "@clerk/clerk-react";
import { Navigate } from "react-router-dom";

const clerkEnabled = Boolean(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY);

export function SignInPage() {
  if (!clerkEnabled) return <Navigate to="/studio" replace />;
  return <div className="flex min-h-screen items-center justify-center px-5 py-16"><SignIn fallbackRedirectUrl="/studio" signUpUrl="/sign-up" /></div>;
}

export function SignUpPage() {
  if (!clerkEnabled) return <Navigate to="/studio" replace />;
  return <div className="flex min-h-screen items-center justify-center px-5 py-16"><SignUp fallbackRedirectUrl="/studio" signInUrl="/sign-in" /></div>;
}
